import React from 'react'

const Hero25 = ({data}) => {
  return (
    <>
      <section className='w-full bg-background py-16 '>
        <div className="container mx-auto px-10 text-center">
            <h1 className='text-5xl text-primary font-semibold'>{DataTransfer.title}</h1>
        </div>

      </section>
    </>
  )
}

export default Hero25
